import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import Register from "../pages/Register";
import MyLeads from "../pages/MyLeads";
import Dashboard from "../pages/Dashboard";
import AddLead from "../pages/AddLead";
import ExploreLeads from "../pages/ExploreLeads";
import LeadDetails from "../pages/LeadDetails";
import Profile from "../pages/Profile";
import ChangePassword from "../pages/ChangePassword";
import OnboardingWizard from "../pages/OnboardingWizard";
import AddLeadWizard from "../pages/AddLeadWizard";

import PrivateRoute from "../components/PrivateRoute";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route path="/register" element={<Register />} />

        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />

        {/* Protected */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-lead-wizard"
          element={
            <PrivateRoute>
              <AddLeadWizard />
            </PrivateRoute>
          }
        />
        
        <Route
          path="/onboarding"
          element={
          
          <OnboardingWizard />
          
          } />
      

        <Route
          path="/my-leads"
          element={
            <PrivateRoute>
              <MyLeads />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-lead"
          element={
            <PrivateRoute>
              <AddLead />
            </PrivateRoute>
          }
        />

        <Route
          path="/explore"
          element={
            <PrivateRoute>
              <ExploreLeads />
            </PrivateRoute>
          }
        />

        <Route
          path="/lead/:id"
          element={
            <PrivateRoute>
              <LeadDetails />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}